export const DEPARTMENT_ERROR_MESSAGES = {
  EMPTY: "should not be empty",
  INCORRECT_ORG_UNIT_FORMAT: `The org code can be between 3-7 characters long and only contain capital letters and hyphens`,
  DUPLICATE: "The org code already exists",
};
